import { transformImage } from "./imageTransformer"
import { MenuItemType } from "../../social-supermarket/model/MenuItemType"
import he from "he"
import { safeHeDecode } from "../../social-supermarket/util/generalUtil"

export const transformMenu = (data = []): MenuItemType[] => {
  const tree = []
  const childrenOf = {}
  data.forEach(gatsbyItem => {
    const menuItem = transformMenuItem(gatsbyItem)
    const { id, parentId } = gatsbyItem
    childrenOf[id] = childrenOf[id] || []
    menuItem["children"] = childrenOf[id]
    parentId
      ? (childrenOf[parentId] = childrenOf[parentId] || []).push(menuItem)
      : tree.push(menuItem)
  })
  return tree
}

export const transformMenuItem = (gatsbyMenuItem): MenuItemType => {
  const {
    id,
    label,
    url,
    custom: { featuredImage, featuredLink },
  } = gatsbyMenuItem
  return {
    id,
    label,
    url,
    featuredLink: featuredLink
      ? {
          title: safeHeDecode(featuredLink.title || ""),
          url: featuredLink.url,
        }
      : null,
    featuredImage: transformImage(featuredImage, "menu featured image"),
    children: [],
  }
}
